import Link from 'next/link';
import { useRouter } from 'next/router';

import useMedia from '~hooks/useMedia';
import useHeaderStore from '~store/header';

import HeaderContentsForDesktop from './HeaderContentsForDesktop';
import HeaderContentsForMobile from './HeaderContentsForMobile';
import ModalBookmarks from './ModalBookmarks';
import ModalCompanyList from './ModalCompanyList';
import * as S from './style';

export default function Header() {
  const router = useRouter();
  const { isDesktop, isMobile, isTablet } = useMedia();
  const {
    isModalBookmarksOpen,
    isModalCompanyListOpen,
    setIsModalBookmarksOpen,
    setIsModalCompanyListOpen,
  } = useHeaderStore();

  return (
    <S.Wrapper>
      <S.InnerWrapper>
        <S.Logo>
          <Link href='/'>
            <a
              data-attribute-id='gnb'
              data-gnb-kind='home'
              onClick={() => {
                if (router.asPath === '/') {
                  window.location.reload();

                  return;
                }
                router.push('/');
              }}>
              <picture>
                <source srcSet='/images/logo-m@2x.png 2x' media='(max-width: 1199px)' />
                <source srcSet='/images/logo@2x.png 2x' />
                <img src='/images/logo.png' alt='크레딧잡' />
              </picture>
            </a>
          </Link>
        </S.Logo>
        {isDesktop && <HeaderContentsForDesktop />}
        {(isMobile || isTablet) && <HeaderContentsForMobile />}
      </S.InnerWrapper>

      {isModalBookmarksOpen && (
        <ModalBookmarks
          isOpen={isModalBookmarksOpen}
          handleClose={() => setIsModalBookmarksOpen(false)}
        />
      )}
      {isModalCompanyListOpen && (
        <ModalCompanyList
          isOpen={isModalCompanyListOpen}
          handleClose={() => setIsModalCompanyListOpen(false)}
        />
      )}
    </S.Wrapper>
  );
}
